import { bool, func, shape, string } from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { get_yes_bank_otp, select_card_data_ybl } from '../NetworkCards/selectors';
import { PhysicalCardActions, fetchCardData } from './actions';
import { selectHeaderContainerJS } from '../HeaderContainer/selectors';
import { getOtp } from '../NetworkCards/actions';
import { PHYSICAL_CARD_ACTIONS } from './constants';
import { isLoading, replaceCardSuccess } from './selectors';


export const YesBankReplaceCardPropTypes = {
  isLoadingStatus: bool.isRequired,
  match: shape({
    params: shape({
      id: string,
      type: string,
    }),
  }).isRequired,
  location: shape({}).isRequired,
  CardDataYbl: shape({}).isRequired,
  SelectUserDetails: shape({}).isRequired,
  onFetchCardData: func.isRequired,
  form: shape({}).isRequired,
  history: shape({}).isRequired,
  GetYesBankOtpSuccess: shape({}).isRequired,
  SetChannelFlagSuccess: shape({}).isRequired,
  onSetChannelFlagSuccess: func.isRequired,
  onSetChannelFlag: func.isRequired,
  onGetOtp: func.isRequired,
};

export const YesBankReplaceCardMapStateToProps = createStructuredSelector({
  CardDataYbl: select_card_data_ybl(),
  SelectUserDetails: selectHeaderContainerJS('userDetails'),
  GetYesBankOtpSuccess: get_yes_bank_otp('getOtpSuccess'),
  SetChannelFlagSuccess: replaceCardSuccess(),
  isLoadingStatus: isLoading(),
});

export const YesBankReplaceCardMapDispatchToProps = (dispatch) => ({
  onFetchCardData: () => dispatch(fetchCardData()),
  onSetChannelFlag: (payload, cardType) => dispatch(PhysicalCardActions(payload, cardType)),
  onGetOtp: (payload) => dispatch(getOtp(payload)),
  onSetChannelFlagSuccess: () => dispatch({ type: PHYSICAL_CARD_ACTIONS, payload: { status: false } }),
});



// WEBPACK FOOTER //
// client/containers/YesBankReplaceCard/yesBankReplaceCardDataHandler.js